import React, { useEffect } from "react";
import { Branding, useParams, BCMSRecord, useBCMSContext, useGlobalController, BCMSStateManagerCRUD, useStateManager, useBCMSModal, useModel } from "bcms-react";
import Classes, { Account, Transaction } from "model";
import TransactionSearch from "./classes/TransactionSearch";

import { PageContainer, PageContentView, LeftColumnContainer, RightColumnContainer, WidgetContainer } from 'components/shared';
import CreditScoreWidget from 'components/shared/widgets/CreditScoreWidget';
import AccountDetailsView from './components/AccountDetailsView';
import TransactionSearchAccordion from './components/TransactionSearchAccordion';
import TransactionsView from './components/TransactionsView';
import TransactionSearchCriteria from './components/TransactionSearchCriteria';
import MobileTransactionsTable from './components/MobileTransactionsTable';
import CreditScoreIframeWidget from "components/shared/widgets/CreditScoreIframeWidget";
import "./styles.css";
import QuickLinksWidget from "components/shared/widgets/QuickLinksWidget";

export default function AccountDetailsPage(props) {
    const bcmsContext = useBCMSContext();
    // Global controller used to cause a refresh of the page when the account details modal
    // updates the account name
    const globalContext = useGlobalController();

    BCMSRecord.globalControllerFor(Classes, bcmsContext);

    const accountID = useParams().accountID ?? "0"; 

    const data = { ...getDefaultPageData(accountID), ...props.data ?? {} };
    const ui = { ...getDefaultPageUI(), ...props.ui ?? {} };

    const controller = (state, setState) => ({
        data: state.data,
        ui: state.ui,

        forceUpdate: (data, ui) => {
          BCMSStateManagerCRUD.init(state)
            .update([ "data" ], data)
            .update([ "ui" ], ui)
            .submit(setState);
        },

        onSearchUpdate: prop => value => {
          BCMSStateManagerCRUD.init(state)
            .update([ "data", "search", prop ], value)
            .submit(setState);
        },

        onSearchAmountUpdate: value => {
          BCMSStateManagerCRUD.init(state)
            .update([ "data", "search", "amount" ], parseFloat(value.amount) === 0 || value.amount === "" ? "" : value)
            .submit(setState);
        },

        onSearchReset: evt => {
          BCMSStateManagerCRUD.init(state)  
            .update([ "data", "search" ], data.search.reset())
            .update([ "data", "submittedSearch"], data.search.reset())
            .update([ "data", "transactions" ], Transaction.initByAccount(accountID))
            .update([ "ui", "searchByCheck" ], false)
            //.update([ "ui", "searchCriteria", "isActive" ], false)
            .update([ "ui", "searchClearSearchButton", "isActive" ], false)
            .submit(setState);
        },

        onSearchSubmit: evt => {
          BCMSStateManagerCRUD.init(state)
            .update([ "data", "transactions" ], state.data.search.filter())
            .update([ "data", "submittedSearch"], TransactionSearch.init(state.data.search.record))
            .update([ "ui", "searchAccordion", "isActive" ], false)
            //.update([ "ui", "searchCriteria", "isActive" ], true)
            .update([ "ui", "searchClearSearchButton", "isActive" ], true)
            .submit(setState);
        },

        onSearchAccordionClick: value => {
          BCMSStateManagerCRUD.init(state)
            .update([ "ui", "searchAccordion", "isActive" ], value)
            .submit(setState);
        },

        onSearchByCheck: evt => {
          BCMSStateManagerCRUD.init(state)
            .update([ "ui", "searchByCheck" ], true)
            .submit(setState);
        },

        onHasMoreClick: evt => {
          BCMSStateManagerCRUD.init(state)
            .update([ "ui", "showMoreTransactions" ], true)
            .submit(setState);
        },

        onItemClick: (key, prop, value) => {
          BCMSStateManagerCRUD.init(state)
            .update([ "ui", key, prop ], value)
            .submit(setState);
        }
    });

    return (
        <PageContainer className="account-details-page" state={ { data, ui } } controller={ controller }>
            <AccountDetailsContent state={ { data, ui } } />
        </PageContainer>
    );
}

export const getDefaultPageData = id => ({
    account: Account.initByType(id ?? "0"),
    search: TransactionSearch.init({ accountID: id ?? "0" }),
    submittedSearch: TransactionSearch.init({ accountID: id ?? "0" }),
    transactions: Transaction.initByAccount(id ?? "0")
});
export const getDefaultPageUI = () => ({
  accountSelect: { isActive: false },
  searchAccordion: { isActive: false },
  // Property "searchCriteria" was used to show/hide the
  // "Displaying: Transaction Type: All Transaction Types; Date Range: Last 30 Days;" text,
  // but now that text is always shown.
  searchCriteria: { isActive: true },
  searchClearSearchButton: { isActive: false },

  searchType: { isActive: false },
  searchDateRange: { isActive: false },

  searchByCheck: false,
  showMoreTransactions: false,

  modal: {
    id: undefined,
    data: {}
  }
});

function AccountDetailsContent(props) {
    const state = props.state;  

    const { data, ui, forceUpdate } = useStateManager();
    const { open } = useBCMSModal();

    useEffect(() => {
      if(state.data.account.id !== data.account.id) {
        forceUpdate(state.data, state.ui);
      }

      if(ui.modal.id !== undefined) {
        open(ui.modal.id, ui.modal.data);
      }
    }, [ props ]);

    const { branding } = useModel();
    const { options } = branding;
    const customClientBIDBranding = options.bid_abi22;

    return (
      <>
      
        <PageContentView>
            <LeftColumnContainer>
                <WidgetContainer>
                    <AccountDetailsView key={ `DetailsView_${ Date.now() }`} />

                    <TransactionSearchAccordion />
                    <TransactionSearchCriteria />

                    <TransactionsView />
                    <MobileTransactionsTable />
                </WidgetContainer>   
            </LeftColumnContainer>
            <Branding id="cs21_abi22" value="true">
                <RightColumnContainer>
                    <Branding id="cs21_abi22" value="true">  <CreditScoreWidget /></Branding>
                    <Branding id="acctdetails_quick_links_abi22" value="true">  <QuickLinksWidget /></Branding>
                </RightColumnContainer>
            </Branding>
        </PageContentView>
    
     
      </>
    );
}